import { render, staticRenderFns } from "./activity-sales.vue?vue&type=template&id=4039671e&scoped=true&"
import script from "./activity-sales.vue?vue&type=script&lang=js&"
export * from "./activity-sales.vue?vue&type=script&lang=js&"
import style0 from "./activity-sales.vue?vue&type=style&index=0&id=4039671e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4039671e",
  null
  
)

export default component.exports